import Vue from 'vue'
import Vuex from 'vuex'
import { IAuthStore, AuthModule } from './modules/auth.module'
import { IUserStore, UserModule } from './modules/user.module'
import { IChainStore, ChainModule } from './modules/chain.module'
import { IFacilityStore, FacilityModule } from './modules/facility.module'
import { IImportStore, ImportModule } from './modules/import.module'
import { IResidentStore, ResidentModule } from './modules/resident.module'
import { IStatementStore, StatementModule } from './modules/statement.module'
import { ICommentStore, CommentModule } from './modules/comment.module'
import { IPermissionsStore, PermissionsModule } from './modules/permissions.module'
import { ITemplateStore, TemplateModule } from './modules/template.module'
import { ITransactionsStore, TransactionsModule } from './modules/transactions.module'
import { IPaymentsState, PaymentsModule } from './modules/payments.module'
import { IHmoState, HmoModule } from '@/store/modules/hmo.module'
import { ClaimModule, IClaimStore } from './modules/claim.module'
import { ITodoStore, TodoModule } from '@/store/modules/todo.module'
import { ILettersStore, LettersModule } from '@/store/modules/letters.module'
import { BatchModule, IBatchStore } from '@/store/modules/batch.module'
import { BillingModule, IBillingStore } from './modules/billing.module'
import { EligibilityTaskModule, IEligibilityTaskStore } from '@/store/modules/eligibilityTask.module'

export interface IStore {
  claim: IClaimStore,
  transactions: ITransactionsStore,
  permissions: IPermissionsStore,
  comment: ICommentStore
  auth: IAuthStore,
  user: IUserStore,
  chain: IChainStore,
  facility: IFacilityStore,
  import: IImportStore,
  resident: IResidentStore,
  statement: IStatementStore,
  template: ITemplateStore,
  payments: IPaymentsState,
  hmo: IHmoState,
  letter: ILettersStore,
  todo: ITodoStore,
  batch: IBatchStore,
  billing: IBillingStore,
  eligibilityTask: IEligibilityTaskStore
}

Vue.use(Vuex)

export const store = new Vuex.Store<IStore>({
  modules: {
    comment: CommentModule,
    auth: AuthModule,
    user: UserModule,
    chain: ChainModule,
    facility: FacilityModule,
    import: ImportModule,
    resident: ResidentModule,
    statement: StatementModule,
    permissions: PermissionsModule,
    template: TemplateModule,
    payments: PaymentsModule,
    transactions: TransactionsModule,
    hmo: HmoModule,
    claim: ClaimModule,
    letter: LettersModule,
    todo: TodoModule,
    batch: BatchModule,
    billing: BillingModule,
    eligibilityTask: EligibilityTaskModule
  }
})
